/* tslint:disable */
/* eslint-disable */
/**
 * RoadFootage.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
/**
 * Check if a given object implements the TakedownNoticeDto interface.
 */
export function instanceOfTakedownNoticeDto(value) {
    let isInstance = true;
    return isInstance;
}
export function TakedownNoticeDtoFromJSON(json) {
    return TakedownNoticeDtoFromJSONTyped(json, false);
}
export function TakedownNoticeDtoFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': !exists(json, 'id') ? undefined : json['id'],
        'createdAt': !exists(json, 'createdAt') ? undefined : (new Date(json['createdAt'])),
        'updatedAt': !exists(json, 'updatedAt') ? undefined : (new Date(json['updatedAt'])),
        'requestorFullName': !exists(json, 'requestorFullName') ? undefined : json['requestorFullName'],
        'requestorOrganisationName': !exists(json, 'requestorOrganisationName') ? undefined : json['requestorOrganisationName'],
        'requestorTitleOrPosition': !exists(json, 'requestorTitleOrPosition') ? undefined : json['requestorTitleOrPosition'],
        'requestorMailingAddress': !exists(json, 'requestorMailingAddress') ? undefined : json['requestorMailingAddress'],
        'requestorPhoneNumber': !exists(json, 'requestorPhoneNumber') ? undefined : json['requestorPhoneNumber'],
        'requestorEmailAddress': !exists(json, 'requestorEmailAddress') ? undefined : json['requestorEmailAddress'],
        'infringingContentUrl': !exists(json, 'infringingContentUrl') ? undefined : json['infringingContentUrl'],
        'originalContentUrl': !exists(json, 'originalContentUrl') ? undefined : json['originalContentUrl'],
        'copyrightOwnerFullName': !exists(json, 'copyrightOwnerFullName') ? undefined : json['copyrightOwnerFullName'],
        'copyrightOwnerPhoneNumber': !exists(json, 'copyrightOwnerPhoneNumber') ? undefined : json['copyrightOwnerPhoneNumber'],
        'copyrightOwnerEmailAddress': !exists(json, 'copyrightOwnerEmailAddress') ? undefined : json['copyrightOwnerEmailAddress'],
    };
}
export function TakedownNoticeDtoToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'createdAt': value.createdAt === undefined ? undefined : (value.createdAt.toISOString()),
        'updatedAt': value.updatedAt === undefined ? undefined : (value.updatedAt.toISOString()),
        'requestorFullName': value.requestorFullName,
        'requestorOrganisationName': value.requestorOrganisationName,
        'requestorTitleOrPosition': value.requestorTitleOrPosition,
        'requestorMailingAddress': value.requestorMailingAddress,
        'requestorPhoneNumber': value.requestorPhoneNumber,
        'requestorEmailAddress': value.requestorEmailAddress,
        'infringingContentUrl': value.infringingContentUrl,
        'originalContentUrl': value.originalContentUrl,
        'copyrightOwnerFullName': value.copyrightOwnerFullName,
        'copyrightOwnerPhoneNumber': value.copyrightOwnerPhoneNumber,
        'copyrightOwnerEmailAddress': value.copyrightOwnerEmailAddress,
    };
}
